import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WhitelabelImage } from '@resident-nx/shared';
import { SuccessScreenWebComponent } from '../../../../atoms/success-screen/success-screen.component';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile-edit-success',
  imports: [TranslateModule, SuccessScreenWebComponent],
  templateUrl: './user-profile-edit-success.component.html',
  styleUrl: './user-profile-edit-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileEditSuccessComponent {
  public whitelabelImage = WhitelabelImage;
}
